"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchGetImpersonationTokenSuccess = watchGetImpersonationTokenSuccess;
exports.getTokenSuccess = getTokenSuccess;

var _effects = require("redux-saga/effects");

var _appActions = require("../actions/appActions");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(watchGetImpersonationTokenSuccess),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getTokenSuccess);

function watchGetImpersonationTokenSuccess() {
  return regeneratorRuntime.wrap(function watchGetImpersonationTokenSuccess$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeEvery)(_appActions.GET_IMPERSONATION_TOKEN_SUCCESS, getTokenSuccess);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function getTokenSuccess(_ref) {
  var payload, access_token;
  return regeneratorRuntime.wrap(function getTokenSuccess$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          access_token = payload.access_token;
          _context2.next = 4;
          return (0, _effects.put)((0, _appActions.setImpersonationToken)(access_token));

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}